import React from 'react';

import Sidebar from '../../../../components/desktop/Sidebar';

import { publicNavbarMenu } from '../../../../structure/menu';

const DesktopSidebar = () => {
  const items = publicNavbarMenu.filter(
    (menuItem) => !menuItem.mobileOnly && !menuItem.disabled
  );

  return (
    <Sidebar
      items={items}
      showRooms={false}
      showAddButton={false}
      showCarousel={false}
      showPropertyListingLink={false}
      showBYBF={false}
      listProps={{ disablePadding: true }}
    />
  );
};

export default DesktopSidebar;
